$shm_mentionstat_items $mol_page
	title \Сбор данных
	item_ids /
	item_query* \
	item_excluded* \
	item_period* \
	item_country* \
	item_language* \
	item_social* \
	item_mass* \
	item_type* \
	item_tags* \
	item_category* \
	item_edit*? null
	item_delete*? null
	merge_title \Сформировать таблицу
	merge_enabled false
	merge_start? null
	status_text \
	status_color \var(--mol_theme_shade)
	body <= body_rows /
	Grid $mol_grid
		records <= records /
		col_ids <= col_ids /
		col_head_content* <= col_head_content* /
		cell_content* <= cell_content* /
		Cell* <= Cell*
		Col_head* <= Col_head*
	Empty $mol_view
		sub / \Добавьте первый статистический срез
	Controls $mol_view
		sub /
			<= Merge $mol_button_major
				title <= merge_title
				enabled <= merge_enabled
				click? <=> merge_start? null
			<= Status $mol_text
				text <= status_text
				style *
					^
					color <= status_color
	Cell* $mol_grid_cell
		sub <= cell_content* /
		style *
			^
			width <= cell_width* \160px
			minWidth <= cell_width* \160px
			maxWidth <= cell_width* \160px
	Col_head* $mol_float
		sub <= col_head_content* /
		style *
			^
			width <= col_width* \160px
			minWidth <= col_width* \160px
			maxWidth <= col_width* \160px
	Actions* $mol_view
		sub /
			<= Edit* $mol_button_minor
				hint \Редактировать
				sub / <= Edit_icon* $mol_icon_edit
				click? <=> item_edit*? null
			<= Delete* $mol_button_minor
				hint \Удалить
				sub / <= Delete_icon* $mol_icon_trash_can
				click? <=> item_delete*? null
